import ModalSentError from 'components/ModalWindows/ModalSentError';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import { AppContext, IAppContext } from 'appState/appContext';
import React, { useCallback, useContext } from 'react';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import { AddWordingsContext, IAddWordingsContext } from '../addWordingsState/addWordingsContext';
import { convertUndefinedFields } from 'utils/helpers';
import { createWording } from 'backend/adminSettings';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, resetFields, dataForSubmit, typeOfModalWindow } =
		useContext<IAddWordingsContext>(AddWordingsContext);

	const handleConfirm = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await createWording(convertedData);
				changeTypeOfModalWindow('success');
			} catch (e) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleReset = useCallback(() => {
		resetFields();
		changeTypeOfModalWindow(null);
	}, []);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			<ModalToConfirm
				onConsentEvent={resetFields}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={handleConfirm}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmSubmit'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleReset}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
		</ModalWrapper>
	);
};
